// extracted by mini-css-extract-plugin
export default {"shared":"\"../../../shared.module.css\"","md":"768px","chooseManyCheckbox":"Checkbox_chooseManyCheckbox__+Crah","chooseManyCheckmark":"Checkbox_chooseManyCheckmark__IZgnR"};